$('body').on('initScripts', function() {
    $('.site-footer__scroll-to-top').on('click', function() {
        let $button = $(this);

        $button.blur();

        // calculate sroll duration based on distance
        let scrollDistance = $(document).scrollTop();

        if (scrollDistance < 0) scrollDistance = scrollDistance * -1;

        let scrollDuration = scrollDistance * 1.5;

        // set max duration
        if (scrollDuration > 1000) scrollDuration = 1000;

        if (!!prefersReducedMotion) scrollDuration = 0;

        $('html, body').stop().animate({
            scrollTop: scrollTo
        }, scrollDuration, 'swing').promise().done();
    });
});
